module.exports = __webpack_public_path__ + "static/img/cx03.e39f41b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cx03.png
// module id = l5+M
// module chunks = 0